import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import SettingsTwoTone from "@mui/icons-material/SettingsTwoTone";
import PaymentTwoTone from "@mui/icons-material/PaymentTwoTone";
import AccountBalanceWalletTwoTone from "@mui/icons-material/AccountBalanceWalletTwoTone";
import CategoryTwoTone from "@mui/icons-material/CategoryTwoTone";

import Inventory2TwoTone from "@mui/icons-material/Inventory2TwoTone";
import PhoneInTalkTwoTone from "@mui/icons-material/PhoneInTalkTwoTone";

import { useSelector } from "react-redux";
import LocalMallTwoTone from "@mui/icons-material/LocalMallTwoTone";

const Sidebarlinks = () => {
  const { isOpen } = useSelector((state) => state.sidebar);

  const listItems = [
    {
      id: 1,
      text: "Dashboard",
      link: "/",
      icon: (
        <TimelineOutlined
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></TimelineOutlined>
      ),
    },
    {
      id: 2,
      text: "Categories",
      links: "/categories",
      links2: "/addcategory",
      subMenus: [
        { id: "2a", text: "Add New", link: "/addcategory" },
        { id: "2b", text: "View All", link: "/categories" },
      ],

      icon: (
        <CategoryTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></CategoryTwoTone>
      ),
    },
    {
      id: 3,
      text: "Products",
      links: "/products",
      links2: "/addproduct",
      subMenus: [
        { id: "3a", text: "Add New", link: "/addproduct" },
        { id: "3b", text: "View All", link: "/products" },
      ],

      icon: (
        <Inventory2TwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></Inventory2TwoTone>
      ),
    },
    {
      id: 4,
      text: "Orders",
      links: "/orders",
      subMenus: [{ id: "4a", text: "View All", link: "/orders" }],

      icon: (
        <LocalMallTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></LocalMallTwoTone>
      ),
    },

    {
      id: 5,
      text: "Transactions",
      links: "/transactions",
      subMenus: [{ id: "5a", text: "View All", link: "/transactions" }],

      icon: (
        <AccountBalanceWalletTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></AccountBalanceWalletTwoTone>
      ),
    },
    {
      id: 6,
      text: "Payments",
      links: "/payments",
      links2: "/addpayments",
      subMenus: [
        { id: "6a", text: "Add New", link: "/addpayments" },
        { id: "6b", text: "View All", link: "/payments" },
      ],

      icon: (
        <PaymentTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PaymentTwoTone>
      ),
    },
    {
      id: 7,
      text: "Support",
      links: "/support",
      links2: "/addsupport",
      subMenus: [
        { id: "7a", text: "Add", link: "/addsupport" },
        { id: "7b", text: "View All", link: "/support" },
      ],
      icon: (
        <PhoneInTalkTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></PhoneInTalkTwoTone>
      ),
    },
    {
      id: 8,
      text: "Settings",
      links: "/profile",
      links2: "/account",
      subMenus: [
        { id: "8a", text: "Profile", link: "/profile" },
        { id: "8b", text: "Account", link: "/account" },
      ],
      icon: (
        <SettingsTwoTone
          sx={{
            transform: isOpen ? "scale(.85)" : "scale(.6)",
          }}
        ></SettingsTwoTone>
      ),
    },
  ];

  return listItems;
};

export default Sidebarlinks;
